import axios from './axiosInstance';

export function getAllRegulationScopesApi() {
    return axios.get('/regulationScopes').then(res => res.data);
}
